import { render, staticRenderFns } from "./user-set-password.component.vue?vue&type=template&id=49deb5e3&scoped=true&"
import script from "./user-set-password.component.ts?vue&type=script&lang=ts&"
export * from "./user-set-password.component.ts?vue&type=script&lang=ts&"
import style0 from "./user-set-password.component.scss?vue&type=style&index=0&id=49deb5e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49deb5e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VForm})
